(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      if (document.body.classList.contains('template-index') && this.querySelector('.pf-d1-header')) return;

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  const pfSyncSaturdayShipping = () => {
    const footer = document.getElementById('main-cart-footer');
    const label = footer?.dataset.saturdayCheckoutLabel;
    const value = footer?.querySelector('.identixweb-order-delivery .deliveryDateValue')?.value || '';
    const parts = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value.trim());
    if (!label || !parts) return;
    const day = Number(parts[1]), month = Number(parts[2]), year = Number(parts[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day || date.getUTCDay() !== 6) return;
    const shipping = window.ODD_CONFIG?.shippingPrice;
    const methodPattern = /^(?:Sábado \/ Saturday|Sábado|Saturday) · 9:00–14:00$/;
    if (shipping && methodPattern.test(shipping.shipping_method) && shipping.shipping_method !== label) {
      window.ODD_CONFIG.shippingPrice = {...shipping, shipping_method: label};
    }
    footer.querySelectorAll('.identixweb-order-delivery .oddtDeliveryShippingPrice').forEach(message => {
      const text = message.textContent.replace(/(?:Sábado \/ Saturday|Sábado|Saturday) · 9:00–14:00/, label)
        .replace('Envío / Shipping:', footer.dataset.shippingPrefix + ':');
      if (message.textContent !== text) message.textContent = text;
    });
  };
  const pfSyncDeliveryDiscounts = () => {
    window.oddDiscountCode = [...new Set(Array.from(
      document.querySelectorAll('#main-cart-footer [is="discount-remove"][data-discount]'),
      button => button.dataset.discount
    ).filter(Boolean))];
  };
  pfSyncDeliveryDiscounts();
  const pfDiscountContainer = document.getElementById('pf-cart-discount-content');
  if (pfDiscountContainer) new MutationObserver(pfSyncDeliveryDiscounts).observe(pfDiscountContainer, {childList: true, subtree: true});
  document.addEventListener('click', event => {
    if (event.target.closest?.('#main-cart-footer [name="checkout"]')) {
      pfSyncDeliveryDiscounts();
      pfSyncSaturdayShipping();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.id === 'cart') {
      pfSyncDeliveryDiscounts();
      pfSyncSaturdayShipping();
    }
  }, true);
  if (!customElements.get('pf-cart-delivery-estimate')) {
    customElements.define('pf-cart-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.update = () => {
          pfSyncSaturdayShipping();
          const value = document.querySelector('.identixweb-order-delivery .deliveryDateValue')?.value || '';
          const parts = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value.trim());
          let saturday = false;
          if (parts) {
            const day = Number(parts[1]), month = Number(parts[2]), year = Number(parts[3]);
            const date = new Date(Date.UTC(year, month - 1, day));
            saturday = date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day && date.getUTCDay() === 6;
          }
          const prefix = saturday ? 'saturday' : 'standard';
          ['label', 'price', 'total'].forEach(key => {
            const element = this.querySelector(`[data-delivery-${key}]`);
            const text = this.dataset[prefix + key[0].toUpperCase() + key.slice(1)];
            if (element && element.textContent !== text) element.textContent = text;
          });
        };
        this.onChange = event => {
          if (event.target.matches?.('.identixweb-order-delivery .deliveryDateValue')) this.update();
        };
        document.addEventListener('change', this.onChange, true);
        const mount = document.querySelector('.identixweb-order-delivery');
        if (mount) {
          this.observer = new MutationObserver(this.update);
          this.observer.observe(mount, {childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['value']});
        }
        this.update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('change', this.onChange, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-choice-collection"] && !Shopify.designMode) return;
  try {
    
  function initPersaCityFilterSelects(root) {
    root.querySelectorAll('.pf-city-quick-filters:not([data-city-select-ready])').forEach(nav => {
      const label = document.createElement('label');
      label.className = 'pf-city-filter-select';
      const name = document.createElement('span');
      name.className = 'visually-hidden';
      name.textContent = nav.getAttribute('aria-label');
      const select = document.createElement('select');
      nav.querySelectorAll('a').forEach(link => {
        const option = document.createElement('option');
        option.value = link.href;
        option.textContent = link.textContent;
        option.defaultSelected = link.hasAttribute('aria-current');
        select.append(option);
      });
      select.addEventListener('change', () => window.location.assign(select.value));
      label.append(name, select);
      nav.after(label);
      nav.dataset.citySelectReady = 'true';
    });
  }
  initPersaCityFilterSelects(document);
  document.addEventListener('shopify:section:load', event => initPersaCityFilterSelects(event.target));
  function initPersaCityIntros(root) {
    const intros = [...root.querySelectorAll('[data-pf-city-intro]')];
    if (root.matches?.('[data-pf-city-intro]')) intros.unshift(root);
    intros.forEach(intro => {
      if (intro.dataset.introReady) return;
      const button = intro.querySelector('.pf-city-longform-intro__toggle');
      const content = intro.querySelector('.pf-city-longform-intro__text');
      if (!button || !content || button.getAttribute('aria-controls') !== content.id) return;
      const setExpanded = expanded => {
        intro.dataset.collapsed = String(!expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      };
      button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
      setExpanded(false);
      button.hidden = false;
      intro.dataset.introReady = 'true';
    });
  }
  initPersaCityIntros(document);
  document.addEventListener('shopify:section:load', event => initPersaCityIntros(event.target));

  function initPersaFilters(root) {
    root.querySelectorAll('.pf-filters:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const toggle = form.querySelector('.pf-filter-toggle');
      const panel = form.querySelector('.pf-filters__panel');
      if (toggle && panel) {
        panel.hidden = panel.hasAttribute('data-collapsed');
        toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
      }
      form.querySelector('[name="sort_by"]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('formdata', event => { for (const [name, value] of [...event.formData.entries()]) { if (value === '') event.formData.delete(name); } });
    });
  }
  initPersaFilters(document);
  document.addEventListener('shopify:section:load', event => initPersaFilters(event.target));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    requestAnimationFrame(() => document.querySelectorAll('.pf-filters').forEach(form => form.reset()));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-collection"] && !Shopify.designMode) return;
  try {
    
  function initPersaCityFilterSelects(root) {
    root.querySelectorAll('.pf-city-quick-filters:not([data-city-select-ready])').forEach(nav => {
      const label = document.createElement('label');
      label.className = 'pf-city-filter-select';
      const name = document.createElement('span');
      name.className = 'visually-hidden';
      name.textContent = nav.getAttribute('aria-label');
      const select = document.createElement('select');
      nav.querySelectorAll('a').forEach(link => {
        const option = document.createElement('option');
        option.value = link.href;
        option.textContent = link.textContent;
        option.defaultSelected = link.hasAttribute('aria-current');
        select.append(option);
      });
      select.addEventListener('change', () => window.location.assign(select.value));
      label.append(name, select);
      nav.after(label);
      nav.dataset.citySelectReady = 'true';
    });
  }
  initPersaCityFilterSelects(document);
  document.addEventListener('shopify:section:load', event => initPersaCityFilterSelects(event.target));
  function initPersaCityIntros(root) {
    const intros = [...root.querySelectorAll('[data-pf-city-intro]')];
    if (root.matches?.('[data-pf-city-intro]')) intros.unshift(root);
    intros.forEach(intro => {
      if (intro.dataset.introReady) return;
      const button = intro.querySelector('.pf-city-longform-intro__toggle');
      const content = intro.querySelector('.pf-city-longform-intro__text');
      if (!button || !content || button.getAttribute('aria-controls') !== content.id) return;
      const setExpanded = expanded => {
        intro.dataset.collapsed = String(!expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      };
      button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
      setExpanded(false);
      button.hidden = false;
      intro.dataset.introReady = 'true';
    });
  }
  initPersaCityIntros(document);
  document.addEventListener('shopify:section:load', event => initPersaCityIntros(event.target));

  function initPersaFilters(root) {
    root.querySelectorAll('.pf-filters:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const toggle = form.querySelector('.pf-filter-toggle');
      const panel = form.querySelector('.pf-filters__panel');
      if (toggle && panel) {
        panel.hidden = panel.hasAttribute('data-collapsed');
        toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
      }
      form.querySelector('[name="sort_by"]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('formdata', event => { for (const [name, value] of [...event.formData.entries()]) { if (value === '') event.formData.delete(name); } });
    });
  }
  initPersaFilters(document);
  document.addEventListener('shopify:section:load', event => initPersaFilters(event.target));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    // Back/forward cache retains edits made before navigation; restore server-applied filters.
    requestAnimationFrame(() => document.querySelectorAll('.pf-filters').forEach(form => form.reset()));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-d1-includes"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-includes')) {
    customElements.define('pf-includes', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        this.controls = [...this.querySelectorAll('[data-item]')];
        this.photos = [...this.querySelectorAll('[data-photo]')];
        this.caption = this.querySelector('[data-caption]');
        this.pinned = 0;
        const header = document.querySelector('.shopify-section-header');
        const visual = this.querySelector('.pf-includes__visual');
        this.resizeObserver = new ResizeObserver(() => {
          this.style.setProperty('--pf-includes-header-height', (header ? header.getBoundingClientRect().height : 0) + 'px');
          this.style.setProperty('--pf-includes-visual-height', visual.getBoundingClientRect().height + 'px');
        });
        if (header) this.resizeObserver.observe(header);
        this.resizeObserver.observe(visual);
        this.controls.forEach(control => {
          control.addEventListener('click', () => {
            this.pinned = Number(control.dataset.item);
            this.show(this.pinned);
            if (!control.classList.contains('pf-includes__pin') && window.matchMedia('(max-width: 749px)').matches) {
              const frame = this.querySelector('.pf-includes__frame');
              const bounds = frame.getBoundingClientRect();
              if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
                const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
                frame.scrollIntoView({ behavior, block: 'start' });
              }
            }
          }, { signal: this.controller.signal });
          if (control.classList.contains('pf-includes__row')) {
            control.addEventListener('pointerenter', event => {
              if (event.pointerType === 'mouse' && window.matchMedia('(min-width: 750px) and (hover: hover)').matches) this.show(Number(control.dataset.item));
            }, { signal: this.controller.signal });
            control.addEventListener('focus', () => this.show(Number(control.dataset.item)), { signal: this.controller.signal });
          }
        });
        this.addEventListener('pointerleave', () => this.show(this.pinned), { signal: this.controller.signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) this.show(this.pinned);
        }, { signal: this.controller.signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') { event.preventDefault(); this.reset(); }
        }, { signal: this.controller.signal });
        this.dataset.ready = '';
      }
      show(item) {
        const view = ({ 2: 'aquapack', 3: this.querySelector('[data-photo="message"] img') ? 'message' : 'details', 4: this.querySelector('[data-photo="sachets"] img') ? 'sachets' : 'details', 5: 'box' })[item] || 'bouquet';
        this.dataset.view = view;
        this.dataset.selected = String(item);
        this.photos.forEach(photo => { photo.hidden = photo.dataset.photo !== view; });
        this.controls.forEach(control => {
          if (control.hasAttribute('aria-pressed')) control.setAttribute('aria-pressed', String(Number(control.dataset.item) === item));
        });
        const row = this.querySelector('.pf-includes__row[data-item="' + item + '"]');
        this.caption.textContent = row ? row.dataset.detailCaption : this.caption.dataset.defaultCaption;
      }
      reset() {
        this.pinned = 0;
        const row = this.querySelector('.pf-includes__row[data-item="1"]');
        if (this.contains(document.activeElement)) row.focus({ preventScroll: true });
        this.show(0);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-d1-occasions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-occasion-scenes')) {
    customElements.define('pf-occasion-scenes', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.row = this.querySelector('.pf-d1-occasion-grid');
        this.controls = this.querySelector('.pf-occasion-controls');
        if (!this.row || !this.controls) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const buttons = this.controls.querySelectorAll('button');
        const update = () => {
          const maximum = this.row.scrollWidth - this.row.clientWidth;
          this.controls.hidden = maximum < 2;
          buttons[0].disabled = this.row.scrollLeft < 2;
          buttons[1].disabled = this.row.scrollLeft >= maximum - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.row.querySelector('.pf-d1-occasion');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.row).columnGap) || 0;
          this.row.scrollBy({
            left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + gap),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal }));
        this.row.addEventListener('scroll', update, { passive: true, signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.row);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-delivery-services-preview"]) return;
  try {
    
  if (!customElements.get('pf-delivery-services-preview')) {
    customElements.define('pf-delivery-services-preview', class extends HTMLElement {
      connectedCallback() {
        if (this.onSelectionChange) return;
        this.onSelectionChange = () => this.updateSummary();
        this.addEventListener('change', this.onSelectionChange);
        this.updateSummary();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onSelectionChange);
        this.onSelectionChange = null;
      }

      updateSummary() {
        const input = this.querySelector('input[type="radio"]:checked');
        if (!input) return;
        const priceCents = Number(input.dataset.priceCents);
        if (!Number.isSafeInteger(priceCents) || priceCents < 0) return;
        this.querySelector('[data-selected-label]').textContent = input.dataset.label;
        this.querySelector('[data-selected-detail]').textContent = input.dataset.detail;
        this.querySelector('[data-selected-price]').textContent = input.dataset.priceLabel;
        this.dataset.selectedService = input.value;
        this.dataset.selectedPriceCents = String(priceCents);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-home-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-collection-rail')) {
    customElements.define('pf-collection-rail', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const track = this.querySelector('.pf-swipe-shop__track');
        const controls = this.querySelector('.pf-swipe-shop__controls');
        const buttons = [...this.querySelectorAll('.pf-swipe-shop__nav')];
        const progress = this.querySelector('.pf-swipe-shop__progress span');
        const controller = new AbortController();
        const options = { signal: controller.signal };
        const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
        const update = () => {
          const maximum = track.scrollWidth - track.clientWidth;
          controls.hidden = maximum <= 2;
          buttons[0].disabled = track.scrollLeft <= 2;
          buttons[1].disabled = track.scrollLeft >= maximum - 2;
          progress.style.width = `${Math.min(100, track.clientWidth / track.scrollWidth * 100)}%`;
          progress.style.left = `${Math.max(0, track.scrollLeft) / track.scrollWidth * 100}%`;
        };
        const move = direction => {
          const card = track.querySelector('.pf-bouquet');
          if (card) track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 12), behavior: motion() });
        };
        buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), options));
        track.addEventListener('scroll', update, { ...options, passive:true });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !matchMedia('(max-width:749px)').matches) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            track.scrollTo({ left:event.key === 'Home' ? 0 : track.scrollWidth, behavior:motion() });
          }
        }, options);
        const observer = new ResizeObserver(update);
        observer.observe(track);
        this.dataset.ready = '';
        update();
        this.cleanup = () => { controller.abort(); observer.disconnect(); };
      }
      disconnectedCallback() {
        this.cleanup?.();
        this.cleanup = null;
        delete this.dataset.ready;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-home-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pf-story-video')) {
    customElements.define('pf-story-video', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-story-play]');
        this.player = this.querySelector('.pf-story__player');
        this.video = this.querySelector('video');
        if (!this.button || !this.player || !this.video) return;
        this.onPlay = () => {
          this.querySelector('.pf-story__still').hidden = true;
          this.player.hidden = false;
          const attempt = this.video.play();
          if (attempt && attempt.catch) attempt.catch(() => {});
          this.video.focus({ preventScroll: true });
        };
        this.button.addEventListener('click', this.onPlay);
      }
      disconnectedCallback() { this.button?.removeEventListener('click', this.onPlay); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pf-noncity-live-collection"] && !Shopify.designMode) return;
  try {
    
  function initPersaCityFilterSelects(root) {
    root.querySelectorAll('.pf-city-quick-filters:not([data-city-select-ready])').forEach(nav => {
      const label = document.createElement('label');
      label.className = 'pf-city-filter-select';
      const name = document.createElement('span');
      name.className = 'visually-hidden';
      name.textContent = nav.getAttribute('aria-label');
      const select = document.createElement('select');
      nav.querySelectorAll('a').forEach(link => {
        const option = document.createElement('option');
        option.value = link.href;
        option.textContent = link.textContent;
        option.defaultSelected = link.hasAttribute('aria-current');
        select.append(option);
      });
      select.addEventListener('change', () => window.location.assign(select.value));
      label.append(name, select);
      nav.after(label);
      nav.dataset.citySelectReady = 'true';
    });
  }
  initPersaCityFilterSelects(document);
  document.addEventListener('shopify:section:load', event => initPersaCityFilterSelects(event.target));
  function initPersaCityIntros(root) {
    const intros = [...root.querySelectorAll('[data-pf-city-intro]')];
    if (root.matches?.('[data-pf-city-intro]')) intros.unshift(root);
    intros.forEach(intro => {
      if (intro.dataset.introReady) return;
      const button = intro.querySelector('.pf-city-longform-intro__toggle');
      const content = intro.querySelector('.pf-city-longform-intro__text');
      if (!button || !content || button.getAttribute('aria-controls') !== content.id) return;
      const setExpanded = expanded => {
        intro.dataset.collapsed = String(!expanded);
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      };
      button.addEventListener('click', () => setExpanded(button.getAttribute('aria-expanded') !== 'true'));
      setExpanded(false);
      button.hidden = false;
      intro.dataset.introReady = 'true';
    });
  }
  initPersaCityIntros(document);
  document.addEventListener('shopify:section:load', event => initPersaCityIntros(event.target));

  function initPersaFilters(root) {
    root.querySelectorAll('.pf-filters:not([data-ready])').forEach(form => {
      form.dataset.ready = 'true';
      const toggle = form.querySelector('.pf-filter-toggle');
      const panel = form.querySelector('.pf-filters__panel');
      if (toggle && panel) {
        panel.hidden = panel.hasAttribute('data-collapsed');
        toggle.addEventListener('click', () => { panel.hidden = !panel.hidden; toggle.setAttribute('aria-expanded', String(!panel.hidden)); });
      }
      form.querySelector('[name="sort_by"]')?.addEventListener('change', () => form.requestSubmit());
      form.addEventListener('formdata', event => { for (const [name, value] of [...event.formData.entries()]) { if (value === '') event.formData.delete(name); } });
    });
  }
  initPersaFilters(document);
  document.addEventListener('shopify:section:load', event => initPersaFilters(event.target));
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    // Back/forward cache retains edits made before navigation; restore server-applied filters.
    requestAnimationFrame(() => document.querySelectorAll('.pf-filters').forEach(form => form.reset()));
  });

  } catch(e) { console.error(e); }
})();
})();
